import { Box } from "@mui/material";
import { ChangeEvent, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TkButton from "../../components/atoms/TkButton";
import TkCheckBox from "../../components/atoms/TkCheckbox";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import { GlobalContext } from "../../context/globalContext";
import { toNumberOrUndefined, useGetNowDate } from "../../utils/useTools";
import "./_style.scss";
import { httpAPI_PRE009 } from "./api/request";
import { infoManual } from "./parts";
import { TkRouteContext } from "../../context/tkRouteContext";
import dayjs from "dayjs";

/**
 * SCRC080008 都道府県社会福祉協議会等への掛金納付対象職員届データの提供の同意について
 * @return SCRC080008
 */

const SCRC080008 = () => {
  const navigate = useNavigate();
  // システム日付
  const dateObject = useGetNowDate();
  const { year, month, date, hour, minute, second } = dateObject;
  const systemDate = new Date(
    year,
    month - 1,
    date,
    hour,
    minute,
    second
  ).toString();
  const [disabled1, setDisabled1] = useState<boolean>(true);
  const [openSuccess1, setOpenSuccess1] = useState<boolean>(false);
  const [openSuccess2, setOpenSuccess2] = useState<boolean>(false);
  const { state, setState } = useContext(GlobalContext);
  const { state: routeState, setState: setRouteState } =
    useContext(TkRouteContext);

  const handleOk = async () => {
    //掛金納付対象職員届データ提供の同意日更新API
    try {
      const res = await httpAPI_PRE009({
        year: toNumberOrUndefined(state.authInfo?.fiscalYear!),
        contractorNo: state.authInfo?.contractorNo!,
        kyoSubmissionAgreeDate:
          openSuccess1 === true
            ? dayjs(systemDate).format("YYYY/MM/DD")
            : undefined, //システム日付
      });

      if (res.resultCd === "I0000") {
        let routerList = routeState.routerList || [];
        if (routerList.length > 1) {
          setRouteState({
            ...routeState,
            routerList: [...routerList.slice(0, routerList.length - 1)],
          });
          navigate(`${routerList[routerList.length - 2].href}`);
        } else {
          setRouteState({});
        }
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    if (!routeState.routerList) {
      navigate("/SCRC020001");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [routeState]);

  return (
    <Box data-testid="SCRC080008PageForTest" className="SCRC080008">
      {infoManual}
      <TkCheckBox
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          const checked = e.target.checked as boolean;
          setDisabled1(!checked);
        }}
        label="データ提供することに被共済職員の同意を取得済み"
      ></TkCheckBox>

      <Box className="btn">
        <TkBackButton />
        <TkButton onClick={() => setOpenSuccess1(true)} disabled={disabled1}>
          データを提供
        </TkButton>
        <TkButton onClick={() => setOpenSuccess2(true)}>提供しない</TkButton>
      </Box>

      <TkMessageDialog
        open={openSuccess1}
        onOky={handleOk}
        onCancel={() => setOpenSuccess1(false)}
        title="確認（都道府県社会福祉協議会等へデータを提供します）"
        contextText="　都道府県社会福祉協議会等へデータの提供を行いますが、問題ないでしょうか。"
        cancelText="いいえ"
        okText="はい"
      />
      <TkMessageDialog
        open={openSuccess2}
        onOky={handleOk}
        onCancel={() => setOpenSuccess2(false)}
        title="確認（都道府県社会福祉協議会等へデータを提供しない）"
        contextText="　都道府県社会福祉協議会等へデータを提供しませんが、問題ないでしょうか。"
        cancelText="いいえ"
        okText="はい"
      />
    </Box>
  );
};

export default SCRC080008;
